import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { VerificarPacienteRoutingModule } from './verificar-paciente-routing.module';
import { VerificarPacienteComponent } from './verificar-paciente.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
  declarations: [VerificarPacienteComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    VerificarPacienteRoutingModule,
    PipesModule,
    FormsModule,
    MatIconModule
  ]
})
export class VerificacionPacientesModule { }
